import { render, staticRenderFns } from "./FacetNav.vue?vue&type=template&id=7dcd0bf3&"
import script from "./FacetNav.vue?vue&type=script&lang=js&"
export * from "./FacetNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FacetNav.vue"
export default component.exports